import WorkDocument from "work/work-agreements/contracts/work-document";

export type ReplaceableDocumentAPIRequestPayload = {
    documentId?: string;
    replacesId?: string;
    /** Link a copy of `documentId` rather than the document itself. Only creating a draft honours it. */
    copy?: boolean;
};

export default class ReplaceableDocumentAPIRequest {
    documentId?: string;
    replacesId?: string;
    copy?: boolean;

    public get payload(): ReplaceableDocumentAPIRequestPayload {
        return {
            documentId: this.documentId,
            replacesId: this.replacesId,
            ...(this.copy && { copy: true })
        };
    }

    constructor(document?: WorkDocument) {
        this.documentId = document?.id.value;
        this.replacesId = document?.replacesId?.value;
        this.copy = document?.copyOnSave === true ? true : undefined;
    }
}
